import isEmpty from 'lodash/isEmpty';

const API_ROOT = __API_HOST__;

// the following check for empty, not nil, to handle '' responses as errors too
export const getApiRoot = () => {
    if (isEmpty(API_ROOT)) {
        throw new Error('API_ROOT never set.');
    }

    return API_ROOT;
};

export const fullUrl = (endpoint: string) => {
    const apiRoot = getApiRoot();
    return endpoint.indexOf(apiRoot) === -1 ? apiRoot + endpoint : endpoint;
};
